<template>
  <section class="sec-qa" v-if="qaList && qaList.length > 0">
    <div class="footer-title" />
    <div class="qa-main" :class="!isShowAll && 'qa-hidden-all'">
      <div v-for="(item, index) in qaList" :key="index">
        <div class="qa-question">Q：{{ item.text }}</div>
        <div class="qa-answer" v-if="typeof item.desc === 'string'" v-html="item.desc" />
        <div class="qa-answer" v-else>
          <div v-for="(child, index) in item.desc" :key="index">
            <div class="sub-title">{{ child.text }}</div>
            <div class="sub-desc" v-html="child.desc" />
          </div>
        </div>
      </div>
    </div>
    <div @click="changeShowState" class="btn-show-wrapper" v-if="!isShowAll">
      <span v-rseat="'click_carnival_qa_more'">点击查看更多<i /></span>
    </div>
    <div @click="changeShowState" class="btn-hidden-wrapper" v-if="isShowAll">
      <span>点击收起<i /></span>
    </div>
  </section>
</template>
<script>
export default {
  data() {
    return {
      isShowAll: false,
    }
  },
  props: {
    qaList: {
      type: Array,
      default: () => {},
      required: true,
    },
  },
  methods: {
    changeShowState() {
      this.isShowAll = !this.isShowAll
    },
  },
}
</script>
<style lang="less">
.sec-qa {
  max-width: 1001px;
  margin: 0 auto 80px;
  .footer-title {
    background-image: url('~@/assets/carnival2020/qa_title.png');
  }
  .qa-main {
    margin-top: 17px;
    &.qa-hidden-all {
      max-height: 450px;
      overflow-y: hidden;
    }
  }
  .qa-question {
    position: relative;
    padding: 19px 21px;
    background: #000000;
    background: linear-gradient(-225deg, transparent 16px, #000000 0);
    line-height: 30px;
    font-size: 22px;
    color: #ceff1a;
    &::before,
    &::after {
      display: inline-block;
      content: '';
      width: 225px;
      height: 33px;
      position: absolute;
      bottom: -15px;
      background-image: url('~@/assets/carnival2020/qa_bg.png');
      background-repeat: no-repeat;
      background-size: 100%;
    }

    &::before {
      right: 210px;
    }
    &::after {
      right: 0;
    }
  }
  .qa-answer {
    padding: 27px 22px;
    font-size: 20px;
    color: #ffffff;
    line-height: 35px;
  }
  .sub-title {
    margin-bottom: 10px;
  }
  .sub-desc {
    margin-bottom: 20px;
  }
}
</style>
